'use client';
/**
 * ScrollReveal.tsx — Client Component island
 * Manages IntersectionObserver for .fade-in elements sitewide on the homepage.
 * Cycle 76-B: extracted from HomepageClient.tsx as a standalone client island.
 * Renders nothing (null) — side-effect only.
 */

import { useEffect } from 'react';

export default function ScrollReveal() {
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.body.classList.add('js-fade-in-active');
    const elements = document.querySelectorAll<HTMLElement>('.fade-in');
    if (prefersReducedMotion) {
      elements.forEach(el => el.classList.add('visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px 10% 0px' });
    elements.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return null;
}
